// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/_xiaozhu@2022.5.14@xiaozhu/wechatapp/css/global_new.css
// module id = 91
// module chunks = 101